<template>
  <b-form @submit.stop.prevent="onSubmit">
    <b-form-group
      :invalid-feedback="String(errors)"
      :state="errors ? false : undefined"
    >
      <InputNestedObject
        v-model="value_"
        required
        max-rows="20"
        @input="errors = undefined"
        @error="errors = $event"
        :state="errors ? false : undefined"
        :disabled="disabled"
      />
    </b-form-group>
    <slot :busy="busy" :disabled="disabled">
      <div class="text-right">
        <LoadingButton
          type="submit"
          variant="primary"
          :busy="busy"
          :disabled="disabled || busy"
        >
          <slot name="button-content">Submit</slot>
        </LoadingButton>
      </div>
    </slot>
  </b-form>
</template>

<script>
import { get } from 'lodash'

import InputNestedObject from '@/components/InputNestedObject.vue'
import { http } from '@/services/http.js'

export default {
  name: 'OptionsFormRaw',
  components: {
    InputNestedObject,
  },
  props: {
    api: String,
    value: Object,
    idKey: {
      type: String,
      default: 'id',
    },
    disabled: Boolean,
    setItem: {
      type: Function,
      default(requestData) {
        const id = requestData?.[this.idKey]
        return (id)
          ? http.put(`/api/${this.api}/${id}/`, requestData)
          : http.post(`/api/${this.api}/`, requestData)
      },
    },
  },
  data() {
    return {
      value_: this.value,
      busy: false,
      errors: null,
    }
  },
  computed: {},
  watch: {
    value(val) {
      this.value_ = val
    },
  },
  methods: {
    async onSubmit() {
      this.errors = null
      this.busy = true
      const result = await this.setItem(this.value_)
        .then(response => response.data)
        .catch(err => {
          if (err.response && err.response.status === 400) {
            this.errors = JSON.stringify(err.response.data)
          } else {
            this.errors = get(err, 'response.data.detail', err)
          }
          throw err
        })
        .finally(() => this.busy = false)
      this.$emit('success', result)
      return result
    },
  },
}
</script>
